<template>
   <kst-page-export
    :catalog="VenSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Excel.Option.List"
    />
    <kst-check 
      v-model="userData.WithAddress"
      :label="Info.Export.List.Excel.Option.VendorAddress"
    />
  </kst-page-export>
</template>

<script>
import Info from "../VenInfo.js";
import Model from "../VenModel.js";
import VenSearchCatalog from "../VenSearchCatalog.js";
import Services from "../../../services/Api/VendorService.js";

import Export from "./VenExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    Model: Model,
    VenSearchCatalog: VenSearchCatalog,
    searchData: {
      Search: ""
    },
    userData: {
      WithList: true,
      WithAddress: true
    },
    searchParams: ["Search"],
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.userData.WithList = true;
      this.userData.WithAddress = true;
    },

    getListOptions() {
      return {
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields,
        withaddress: this.$kst.Out.getBoolean(this.userData.WithAddress)
      };
    }
  }
}
</script>